import { usePermissions } from 'hooks/usePermissions';
import { useGatewayConversionSettings } from 'pages/Monitoring/OrderConversion/OrderConversionList/hooks/useGatewayConversionSettings';
import { useRecordContext } from 'react-admin';
import { AddIconButton, EditIconButton } from 'shared/mui/IconButtons';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { GatewayConversionListItem } from 'types/embedded/orderConversion';
import { Permission } from 'types/embedded/permission';

type Props = Omit<FunctionFieldProps, 'render'> & {
  onOpenCreateModal: (record: GatewayConversionListItem | undefined) => void;
  onOpenEditModal: (record: GatewayConversionListItem | undefined) => void;
};

export const OrderConversionListDatagridTresholdsField: React.FC<Props> = ({
  onOpenEditModal,
  onOpenCreateModal,
  ...restProps
}) => {
  const record = useRecordContext<GatewayConversionListItem>();
  const { hasResourcePermissions } = usePermissions();

  const { data: settings } = useGatewayConversionSettings(
    record?.gatewayConversionSettingId || null,
  );

  return (
    <FunctionField
      render={() => {
        return (
          <>
            {settings
              ? hasResourcePermissions('gateway_conversion_settings', [
                  Permission.Full,
                  Permission.Update,
                ]) && (
                  <EditIconButton
                    color="secondary"
                    onClick={() => {
                      onOpenEditModal(record);
                    }}
                  />
                )
              : hasResourcePermissions('gateway_conversion_settings', [
                  Permission.Full,
                  Permission.Create,
                ]) && (
                  <AddIconButton
                    color="secondary"
                    onClick={() => {
                      onOpenCreateModal(record);
                    }}
                  />
                )}
          </>
        );
      }}
      {...restProps}
    />
  );
};
